import { getHashForString } from '../_utils';

// Get random background colors for avatar component
export const getRandomBgClassNameFromName = (name: string): string => {
  const classNames: string[] = [
    'bgPurpleBase',
    'bgGrayBase',
    'bgBlueBase',
    'bgTealBase',
    'bgGreenBase',
    'bgOrangeBase',
  ];
  // To keep consistent bg color for same name, generate index based on the name
  const hash = getHashForString(name);
  const index = hash % classNames.length;
  return classNames[index];
};
